// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__333mn","container":"styles_container__1rCp5","title":"styles_title__BCOeF","wrapper":"styles_wrapper__3XeFF","answer":"styles_answer__26b64"};